export default __webpack_public_path__ + "8b697a0ba276c3b682246f5f05ecf75c.png";